import script from "./ListarSupervisoes.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarSupervisoes.vue?vue&type=script&setup=true&lang=js"

import "./ListarSupervisoes.vue?vue&type=style&index=0&id=380bdc09&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-380bdc09"]])

export default __exports__